'use client'

import { useModals, useSearchParams } from '@/lib/hooks'
import { getOrderPropertiesCallback, clearOrderPropertiesCallback } from '@/lib/utils/order-properties-callback'
import type React from 'react'
import { use } from 'react'

import { SetOrderProperties } from '@/components/forms/set-order-properties'
import { RefContext, type Refs } from '@/components/providers/ref-provider'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui'

interface SetOrderPropertiesModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const SetOrderPropertiesModal = ({ open }: SetOrderPropertiesModalProps) => {
  const { closeModal } = useModals()
  const { cartId } = useSearchParams()
  const { barcodeInputRef } = use(RefContext) as Refs

  const handleClose = () => {
    closeModal('SET_ORDER_PROPERTIES')
    // Clear the callback after closing
    clearOrderPropertiesCallback()
  }

  return (
    <Dialog open={open} onOpenChange={() => barcodeInputRef.current?.focus()}>
      <DialogContent
        closeOnOverlay
        onClose={handleClose}
        size="lg"
        className="min-h-[200px] lg:max-w-[600px]"
      >
        <DialogTitle>Set Order Properties</DialogTitle>

        {cartId && (
          <SetOrderProperties
            cartId={cartId}
            onClose={handleClose}
            onSuccess={getOrderPropertiesCallback() || undefined}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
